// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Copy = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Copy = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Copy = _exports.Copy = function Copy(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.6875 5.20833H11.9792C13.7933 5.20833 14.7917 6.20667 14.7917 8.02083V15.3125C14.7917 17.1267 13.7933 18.125 11.9792 18.125H4.6875C2.87333 18.125 1.875 17.1267 1.875 15.3125V8.02083C1.875 6.20667 2.87333 5.20833 4.6875 5.20833ZM3.125 15.3125C3.125 16.4225 3.5775 16.875 4.6875 16.875H11.9792C13.0892 16.875 13.5417 16.4225 13.5417 15.3125V8.02083C13.5417 6.91083 13.0892 6.45833 11.9792 6.45833H4.6875C3.5775 6.45833 3.125 6.91083 3.125 8.02083V15.3125ZM16.875 4.68333V11.9833C16.875 12.9817 16.4724 13.2275 16.3399 13.3092C16.0449 13.4892 15.9534 13.8742 16.1334 14.1683C16.2518 14.3608 16.4566 14.4667 16.6675 14.4667C16.7783 14.4667 16.8917 14.4367 16.9934 14.375C17.7442 13.915 18.125 13.1108 18.125 11.9833V4.68333C18.125 2.89833 17.1007 1.875 15.3166 1.875H8.01676C6.6126 1.875 5.94167 2.49081 5.625 3.00664C5.445 3.30081 5.53754 3.68581 5.83171 3.86581C6.12671 4.04665 6.51004 3.95333 6.69088 3.65916C6.77171 3.52666 7.01843 3.12419 8.01676 3.12419H15.3166C16.4232 3.12502 16.875 3.57666 16.875 4.68333Z",
      fill: "#212B36"
    }));
  };
});
